import {Assignment} from "./assignment";

export enum RegistrationStateType {
    InProcess,
    Accepted,
    Rejected,
    Registered,
    Suspended
}

export const RegistrationStateText = [
    'procedowany',
    'potwierdzony',
    'cofnięty',
    'wpisany na listę',
    'decyzja wstrzymana'
]

export enum RequestType {
    Active,
    Reserve,
    Vacations,
    Exit
}

export const RequestTypeText = [
    'wpis na listę czynnych instruktorów',
    'przeniesienie do rezerwy',
    'urlop'
]

export const InstructorText = [
    'PWD',
    'PHM',
    'HM'
]

export interface Census {
    Id?: string;
    RegistrantId: string,
    RegistrationState: RegistrationStateType,
    Request: RequestType,
    VacationStartDate?: string,
    VacationEndDate?: string,
    RegistrantComment?: string
    StateAwards?: string,
    CreateDate: string
    YPSResidence: string;
    YPSCitizenship: string;
    YPSAccept: boolean;
    YPSKRKSent: boolean;
    KRKIssueDate: string;
    AssignmentsDTO: Assignment[]
}